import { Stack, Text, Box } from '@mantine/core';
import { AfaLoader, AfaLoaderSize } from '../AfaLoader';

export interface AfaSectionLoaderProps {
  /**
   * Mensaje a mostrar
   * @default "Carregant dades..."
   */
  message?: string;
  /**
   * Tamaño del loader
   * @default "lg"
   */
  size?: AfaLoaderSize;
  /**
   * Padding interno del contenedor
   * @default "xl"
   */
  padding?: string | number;
  /**
   * Altura mínima del contenedor (útil para mantener layout)
   */
  minHeight?: string | number;
}

/**
 * AfaSectionLoader - Loader para secciones/contenedores específicos
 * 
 * Uso típico dentro de ContainerWhite o secciones:
 * ```tsx
 * <ContainerWhite>
 *   {loading ? (
 *     <AfaSectionLoader message="Cargando trameses..." />
 *   ) : (
 *     <DataComponent />
 *   )}
 * </ContainerWhite>
 * ```
 * 
 * Ejemplos:
 * ```tsx
 * // Básico
 * <AfaSectionLoader />
 * 
 * // Personalizado
 * <AfaSectionLoader 
 *   message="Cargando avisos y terminis..." 
 *   size="md"
 *   padding="md"
 *   minHeight="200px"
 * />
 * ```
 */
export function AfaSectionLoader({ 
  message = "Carregant dades...", 
  size = "lg",
  padding = "xl",
  minHeight
}: AfaSectionLoaderProps) {
  return (
    <Box mih={minHeight}>
      <Stack align="center" p={padding}>
        <AfaLoader size={size} />
        <Text c="dimmed">{message}</Text>
      </Stack>
    </Box>
  );
}